<script lang="ts">
	import { browser } from '$app/environment';
	import { page } from '$app/stores';
	import Header from '$lib/components/Header.svelte';
	import { handlePaysoMessage } from '$lib/payment/paysoBridge';
	import { token_sso_id } from '$lib/stores/pricing';
	import { PUBLIC_3DPRINTING_URL } from '$env/static/public';
	import PDPAConsent from '$lib/components/PDPAConsent.svelte';
	import { onDestroy, onMount } from 'svelte';

	const handleLogOut = () => {
		// Clear the SSO tokens on logout
		token_sso_id.set('');
		//go to /3dprintingservice
		window.location.href = '/3dprintingservice';
	};

	// Get all query parameters from URL and build additional params
	// Safe for prerendering - only access searchParams in browser
	$: queryParams = browser ? $page.url.searchParams : new URLSearchParams();
	$: additionalParams = (() => {
		const params = new URLSearchParams();
		// Add all query parameters except token (already handled)
		queryParams.forEach((value, key) => {
			if (key !== 'token') {
				params.append(key, value);
			}
		});
		return params;
	})();

	// Build iframe URL with all parameters
	$: iframeUrl = (() => {
		const baseUrl = `${PUBLIC_3DPRINTING_URL}?token=${$token_sso_id}`;
		const additionalQuery = additionalParams.toString();
		return additionalQuery ? `${baseUrl}&${additionalQuery}` : baseUrl;
	})();

	onMount(() => {
		window.addEventListener('message', handlePaysoMessage);
	});

	onDestroy(() => {
		if (browser) {
			window.removeEventListener('message', handlePaysoMessage);
		}
	});
</script>

<svelte:head>
	<title>บริการพิมพ์ 3D | 3D Printing Service – 3dai.co.th</title>
	<meta name="description" content="บริการพิมพ์ 3D จาก 3DAI – ส่งไฟล์โมเดลจาก 3d ai มาพิมพ์ 3D ได้ที่ 3dai.co.th (3dai)" />
	<meta name="keywords" content="3d ai, 3dai, 3dai.co.th, บริการพิมพ์ 3D, 3D printing service, พิมพ์ 3 มิติ" />
	<meta name="robots" content="index, follow" />
	<meta property="og:title" content="บริการพิมพ์ 3D | 3D Printing Service – 3dai.co.th" />
	<meta property="og:description" content="บริการพิมพ์ 3D จาก 3DAI – ส่งโมเดลจาก 3d ai มาพิมพ์ได้ที่ 3dai.co.th" />
	<meta property="og:url" content="https://3dai.co.th/3dprintingservice" />
	<meta property="og:site_name" content="3DAI" />
</svelte:head>

<div class="printing_header">
	<Header pageName="3D Printing Service" onLogOut={handleLogOut} />
</div>
<iframe
	src={iframeUrl}
	style="width: 100%;
		height: 100vh;
		border: none;
		overflow: hidden;
		"
	title="Pricing Page"
></iframe>

<!-- PDPA Consent Banner -->
<PDPAConsent />

<style scoped>
	.printing_header .transparent-header {
		right: 180px !important;
		width: auto !important;
	}
</style>
